import React, { useState } from "react";
import { Link } from "react-router-dom";
import {NotificationContainer, StyledContainer, StyledPasswordReset} from "./passwordReset.style";
import {
    ErrorContainer,
    FixelLogo, FormContainer, Row,
    StyledButton,
    StyledInput,
    StyledLabel, StyledLeftForm, StyledRightForm,
    StyledTitle
} from "../signIn/signin.style";
import Firebase from "../../services/firebase";
import Recommendation from "../commons/recommendation/recommendation.compoenent";
import {getRecommendee} from "../commons/recommendation/recommendationList";

const PasswordReset = () => {
    const [email, setEmail] = useState("");
    const [emailHasBeenSent, setEmailHasBeenSent] = useState(false);
    const [error, setError] = useState(null);
    const onChangeHandler = event => {
        const { name, value } = event.currentTarget;
        if (name === "userEmail") {
            setEmail(value);
        }
    };
    const sendResetEmail = event => {
        event.preventDefault();
        Firebase.auth
            .sendPasswordResetEmail(email)
            .then(() => {
                setEmailHasBeenSent(true);
                setTimeout(() => {setEmailHasBeenSent(false)}, 5000);
            })
            .catch(() => {
                setError("Error resetting password");
            });
    };

    return (
        <StyledPasswordReset>
            <FixelLogo/>
            <StyledContainer>
                <StyledLeftForm>
                    <FormContainer>
                        <form action="">
                            {emailHasBeenSent && (
                                <NotificationContainer>
                                    An email has been sent to you!
                                </NotificationContainer>
                            )}
                            {error !== null && (
                                <ErrorContainer>
                                    {error}
                                </ErrorContainer>
                            )}
                            <StyledTitle>
                                Reset your Password
                            </StyledTitle>
                            <StyledLabel htmlFor="userEmail">
                                Email:
                            </StyledLabel>
                            <StyledInput
                                type="email"
                                name="userEmail"
                                id="userEmail"
                                value={email}
                                placeholder="Input your email"
                                onChange={onChangeHandler}
                            />
                        </form>
                        <Row>
                            <StyledButton
                                className="w-full bg-blue-400 text-white py-3"
                                onClick={event => {
                                    sendResetEmail(event);
                                }}
                            >
                                Send me a reset link
                            </StyledButton>
                            <Link to ="/">&larr; back to sign in page </Link>
                        </Row>
                    </FormContainer>
                </StyledLeftForm>
                <StyledRightForm>
                    <Recommendation/>
                </StyledRightForm>
            </StyledContainer>
        </StyledPasswordReset>
    );
};
export default PasswordReset;